var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHarvest = function SvgHarvest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M4 10v10h16V10H4zm0-2h16c1 0 2 1 2 2v10c0 1-1 2-2 2H4c-1 0-2-1-2-2V10c0-1 1-2 2-2zm3 6a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.047 8h-2.008c.17-2.138.898-4.022 2.18-5.625a1 1 0 0 1 1.562 0C18.063 3.978 18.79 5.862 18.96 8h-2.008c-.113-1.178-.43-2.243-.953-3.203-.523.96-.84 2.025-.953 3.203zm.961 8h-.017.017zM10 4.126c1.725.444 3 2.01 3 3.874h-2a2 2 0 1 0-4 0H5a4.002 4.002 0 0 1 3-3.874V4a1 1 0 1 1 2 0v.126z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHarvest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/harvest.72f38505.svg";
export { ForwardRef as ReactComponent };